import { Link, redirect } from 'react-router'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { getUserId } from '#app/utils/auth.server.ts'
import { type Route } from './+types/index.ts'

export const meta: Route.MetaFunction = () => [{ title: 'HEP Reports' }]

export async function loader({ request }: Route.LoaderArgs) {
	// Signed-in people never need the landing page
	const userId = await getUserId(request)
	if (userId) throw redirect('/dashboard')
	return {}
}

export default function Index() {
	return (
		<main className="grid flex-1 place-items-center px-4 py-16">
			<div className="flex max-w-xl flex-col items-center text-center">
				<p className="text-muted-foreground mb-3 text-xs font-semibold tracking-[0.2em] uppercase">
					HEP is on the way
				</p>
				<h1 className="text-h1 text-balance">The HEP everything app</h1>
				<p className="text-muted-foreground mt-5 max-w-md text-lg text-balance">
					Calls, job booking, tasks, and reports in one place, built on live
					ServiceTitan data. Sign in with your HEP account to get started.
				</p>
				<div className="mt-10 flex flex-wrap items-center justify-center gap-3">
					<Button asChild size="lg">
						<Link to="/login">
							<Icon name="lock-open-1" className="mr-1.5">
								Sign in
							</Icon>
						</Link>
					</Button>
					<Button asChild size="lg" variant="secondary">
						<Link to="/signup">Create an account</Link>
					</Button>
				</div>
				<p className="text-muted-foreground mt-6 text-sm">
					Have a Microsoft 365 account at HEP? Use{' '}
					<span className="inline-flex items-center gap-1 font-medium">
						<Icon name="microsoft-logo" size="sm" /> Sign in with Microsoft
					</span>{' '}
					on the login page — no password needed.
				</p>
			</div>
		</main>
	)
}
